var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { loginClientId, loginClientSecret, apiBaseUrl } from "../config";
import { post } from "../api";
export const login = (username, password) => __awaiter(void 0, void 0, void 0, function* () {
    let loginData = new FormData();
    let authorizationHeader = btoa(`${loginClientId}:${loginClientSecret}`);
    try {
        /***
         * mobile follows jwt login process which is based off of oauth2 login
         * below are the rfc on how login is done
         * https://tools.ietf.org/html/rfc6749
         * https://tools.ietf.org/html/rfc7519
         * https://tools.ietf.org/html/rfc7523
         * https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS
         */
        loginData.set("username", username);
        loginData.set("password", password);
        loginData.set("grant_type", "password");
        loginData.set("client_id", loginClientId);
        loginData.set("client_secret", loginClientSecret);
    }
    catch (error) {
        throw error;
    }
    return yield post(`${apiBaseUrl}/oauth/token`, loginData, {
        headers: {
            Accept: "*",
            "Content-Type": "multipart/form-data",
            Authorization: `Basic ${authorizationHeader}`,
        },
        getData: data => data.access_token,
    });
});
export const signup = (email, password, gender) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield post(`${apiBaseUrl}/website/user/signup`, {
        subscriptionEmails: false,
        language: "en",
        timezone: getTimezone(),
        clientId: loginClientId,
        email,
        password,
        firstName: "",
        lastName: "",
        gender,
    }, { headers: { Authorization: undefined } })).access_token;
});
const getTimezone = () => /\((.*)\)/.exec(new Date().toString())[1];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9naW4uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaGVscGVycy9sb2dpbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFHQSxPQUFPLEVBQUUsYUFBYSxFQUFFLGlCQUFpQixFQUFFLFVBQVUsRUFBRSxNQUFNLFdBQVcsQ0FBQztBQUV6RSxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sUUFBUSxDQUFDO0FBRTlCLE1BQU0sQ0FBQyxNQUFNLEtBQUssR0FBRyxDQUNqQixRQUFnQixFQUNoQixRQUFnQixFQUNELEVBQUU7SUFDakIsSUFBSSxTQUFTLEdBQUcsSUFBSSxRQUFRLEVBQUUsQ0FBQztJQUMvQixJQUFJLG1CQUFtQixHQUFHLElBQUksQ0FBQyxHQUFHLGFBQWEsSUFBSSxpQkFBaUIsRUFBRSxDQUFDLENBQUM7SUFDeEUsSUFBSTtRQUNBOzs7Ozs7O1dBT0c7UUFFSCxTQUFTLENBQUMsR0FBRyxDQUFDLFVBQVUsRUFBRSxRQUFRLENBQUMsQ0FBQztRQUNwQyxTQUFTLENBQUMsR0FBRyxDQUFDLFVBQVUsRUFBRSxRQUFRLENBQUMsQ0FBQztRQUNwQyxTQUFTLENBQUMsR0FBRyxDQUFDLFlBQVksRUFBRSxVQUFVLENBQUMsQ0FBQztRQUN4QyxTQUFTLENBQUMsR0FBRyxDQUFDLFdBQVcsRUFBRSxhQUFhLENBQUMsQ0FBQztRQUMxQyxTQUFTLENBQUMsR0FBRyxDQUFDLGVBQWUsRUFBRSxpQkFBaUIsQ0FBQyxDQUFDO0tBQ3JEO0lBQUMsT0FBTyxLQUFLLEVBQUU7UUFDWixNQUFNLEtBQUssQ0FBQztLQUNmO0lBQ0QsT0FBTyxNQUFNLElBQUksQ0FBUyxHQUFHLFVBQVUsY0FBYyxFQUFFLFNBQVMsRUFBRTtRQUM5RCxPQUFPLEVBQUU7WUFDTCxNQUFNLEVBQUUsR0FBRztZQUNYLGNBQWMsRUFBRSxxQkFBcUI7WUFDckMsYUFBYSxFQUFFLFNBQVMsbUJBQW1CLEVBQUU7U0FDaEQ7UUFDRCxPQUFPLEVBQUUsSUFBSSxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsWUFBWTtLQUNyQyxDQUFDLENBQUM7QUFDUCxDQUFDLENBQUEsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLE1BQU0sR0FBRyxDQUNsQixLQUFhLEVBQ2IsUUFBZ0IsRUFDaEIsTUFBYyxFQUNDLEVBQUU7SUFDakIsT0FBTyxDQUNILE1BQU0sSUFBSSxDQUNOLEdBQUcsVUFBVSxzQkFBc0IsRUFDbkM7UUFDSSxrQkFBa0IsRUFBRSxLQUFLO1FBQ3pCLFFBQVEsRUFBRSxJQUFJO1FBQ2QsUUFBUSxFQUFFLFdBQVcsRUFBRTtRQUN2QixRQUFRLEVBQUUsYUFBYTtRQUN2QixLQUFLO1FBQ0wsUUFBUTtRQUNSLFNBQVMsRUFBRSxFQUFFO1FBQ2IsUUFBUSxFQUFFLEVBQUU7UUFDWixNQUFNO0tBQ1QsRUFDRCxFQUFFLE9BQU8sRUFBRSxFQUFFLGFBQWEsRUFBRSxTQUFTLEVBQUUsRUFBRSxDQUM1QyxDQUNKLENBQUMsWUFBWSxDQUFDO0FBQ25CLENBQUMsQ0FBQSxDQUFDO0FBRUYsTUFBTSxXQUFXLEdBQUcsR0FBVyxFQUFFLENBQUMsVUFBVSxDQUFDLElBQUksQ0FBQyxJQUFJLElBQUksRUFBRSxDQUFDLFFBQVEsRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMifQ==